 <!--Designed & Developed by:
    Nirmal K (@cyberwizard1001)⁶
    Nitin Ravi (@nitinravi)
    Ritwik M (@ritwik-m) &
    Nalinadevi K 
 for the Ministry of Education (MOE) virtual-labs project, Govt. Of India -->


<script>

</script>

<template>
    <main>
        <div class="flex">
            <div class="codebox">

            <h3 style="font-family: monospace;">Test Driver.java</h3>
            <pre>
import java.util.Scanner;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		
		
		//RentalSystem rentalSystem = new RentalSystem();
		//Singleton Pattern Demo
		RentalSystem rentalSystem = RentalSystem.getRentalSystem();
		
		rentalSystem.execobj=new Exec[1];
		rentalSystem.execobj[0]=new Person.PersonBuilder("EFG")
				.withEmail("efg@gmail.com")
				.withCity("Coimbatore")
				.buildExec();
		
		rentalSystem.cobj= new Customer[3];
		rentalSystem.cobj[0]=new Person.PersonBuilder("ABC")
				.withEmail("abc@gmail.com")
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[1]=new Person.PersonBuilder("DEF")
				.withPhone(8654678976L)
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[2]=new Person.PersonBuilder("GHI")
				.withEmail("ghi@gmail.com")
				.withPhone(1234567890L)
				.withCity("Chennai")
				.buildCustomer();
		
		rentalSystem.vobj = new Vehicle[2];
		rentalSystem.vobj[0]=new WeekEndDecorator(new HiringVehicle(1234,3000));
		rentalSystem.vobj[1]=new PeakSeasonDecorator
                        (new AfterNoonDecorator(new HiringVehicle(3456,2500)));
				
		rentalSystem.robj=new Reservation[1];
		rentalSystem.robj[0]= new Reservation
                    (rentalSystem.cobj[0],rentalSystem.vobj[0]);
		SimpleDateFormat sdformat = new SimpleDateFormat("yyyy-MM-dd");
        Date d = sdformat.parse("2022-02-29");
		rentalSystem.robj[0].setBookingDate(d);
		rentalSystem.robj[0].setContractStatus("Reservation not released");
		System.out.println("Hiring rate of the vehicle " + 
                    rentalSystem.vobj[0].getRegNum() + " is " +rentalSystem.vobj[0].getHireRatePerDay());
		System.out.println("Hiring rate of the vehicle " + 
                    rentalSystem.vobj[1].getRegNum() + " is " +rentalSystem.vobj[1].getHireRatePerDay());
				
		rentalSystem.visitOffice(rentalSystem.robj[0]);
	}	
}
            </pre>
        </div>


        <div class="outbox">
                    <p>OUTPUT</p>   
                   <p style="color: #fff;">Hiring rate of the vehicle 1234 is 2700.0</p>
                   <p style="color: #fff;">Hiring rate of the vehicle 3456 is 2933.125</p>
                    <p style="color: #fff;">Vehicle 1234 is available, Customer ABC is initiating contract..</p>
                    <p style="color: #fff;">Reservation released</p>
                    <p style="color: #fff;">Vehicle key handedover</p><br>
                    <p style="color: #fff;">Process finished with exit code 0</p>
                    

                    <div style="height: 100px; background-color: #202020;"></div>
                        <button class="button-9" id="btn1" @click="$router.push('/screen-three')">Continue</button>

                    </div>

                </div>
        
    </main>
</template>

<style scoped>
* {
    box-sizing: border-box;
    background-color: #F9FAFE;
}


h1,
h2,
p {
    font-family: sans-serif;
    color: rgb(0, 3, 40);
}

.column {
    float: left;
    width: 50%;
}

/* Clear floats after the columns */
.row:after {
    content: "";
    display: table;
    clear: both;
}

.comment {
  margin-left: 15px;
  font-style: italic;
  color: gray;
  font-size: small;
}




mark1 {
    background-color: rgb(176, 230, 183);
    box-shadow: 1px 6px 15px 2px rgb(160, 222, 159);
    color: black;
    border-radius: 10px;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 6px;
    padding-bottom: 6px;
}

mark0 {
    box-shadow: 1px 6px 15px 2px rgb(249, 255, 191);
    background-color: rgb(231, 238, 162);
    color: black;
    border-radius: 10px;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 6px;
    padding-bottom: 6px;
}

#comment {
    margin-left: 15px;
    font-style: italic;
    color: gray;
    font-size: small;
}

.flex{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    flex-direction: row;
}




.codebox {
    height: 80%;
    width: fit-content;
    margin: 25px;
    padding: 25px;
    border-radius: 10px;
    
    box-shadow: 2px 3px 10px 2px #D7DFFF;
}

.outbox {
    height: 80%;
    min-height: 50vh;
    width: 50%;
    margin: 25px;
    padding: 25px;
    border-radius: 10px;
    background-color: #202020;
    color: white;
    font-size: medium;
    font-family: monospace;
    font-weight: bold;
    box-shadow: 2px 3px 10px 2px #D7DFFF;
}

.outbox p{
    background-color: inherit;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
}

input {
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 4px;
    font-size: 14px;
    background-color: white;
    color: black;
}

/* CSS */
.button-9 {
    appearance: button;
    backface-visibility: hidden;
    background-color: #405cf5;
    border-radius: 6px;
    border-width: 0;
    box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .1) 0 2px 5px 0, rgba(0, 0, 0, .07) 0 1px 1px 0;
    box-sizing: border-box;
    color: #fff;
    cursor: pointer;
    font-family: -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Ubuntu, sans-serif;
    font-size: 100%;
    height: 44px;
    line-height: 1.15;
    margin: 12px 0 0;
    outline: none;
    overflow: hidden;
    padding: 0 25px;
    position: relative;
    text-align: center;
    text-transform: none;
    transform: translateZ(0);
    transition: all .2s, box-shadow .08s ease-in;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    width: 200px;
}

.button-9:disabled {
    cursor: default;
}

.button-9:focus {
    box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .2) 0 6px 15px 0, rgba(0, 0, 0, .1) 0 2px 2px 0, rgba(50, 151, 211, .3) 0 0 0 4px;
}
</style>